module.exports = __webpack_public_path__ + "static/media/daycareBrainToysIcon.f5153629.png";